import firebase from "firebase/app";
import { tAnnouncement, tBrand, tProduct, tPromotion, validate } from "tmt_api/src/types/types.validator";

export const documentBrand = (id: string): firebase.firestore.DocumentReference<tBrand> => {
  return firebase
    .firestore()
    .collection("brands")
    .doc(id)
    .withConverter<tBrand>({
      toFirestore: (data) => data,
      fromFirestore: (snapshot) => validate("tBrand")(snapshot.data()),
    });
};

export const documentBrandProduct = (id: string, productId: string): firebase.firestore.DocumentReference<tProduct> => {
  return firebase
    .firestore()
    .collection("brands")
    .doc(id)
    .collection("products")
    .doc(productId)
    .withConverter<tProduct>({
      toFirestore: (data) => data,
      fromFirestore: (snapshot) => validate("tProduct")(snapshot.data()),
    });
};

export const queryBrands = (): firebase.firestore.Query<tBrand> => {
  const collectionRef: firebase.firestore.Query = firebase.firestore().collection("brands");
  return collectionRef.withConverter<tBrand>({
    toFirestore: (data) => data,
    fromFirestore: (snapshot) => validate("tBrand")(snapshot.data()),
  });
};

export const queryBrandPromotions = (
  id: string,
  params?: { isPrivate?: boolean; isDeactivated?: boolean; endDate?: firebase.firestore.Timestamp },
): firebase.firestore.Query<tPromotion> => {
  let collectionRef: firebase.firestore.Query = firebase
    .firestore()
    .collection("promotions")
    .where("brandId", "==", id);

  if (params?.isPrivate !== undefined) collectionRef = collectionRef.where("isPrivate", "==", params.isPrivate);
  if (params?.isDeactivated !== undefined)
    collectionRef = collectionRef.where("deactivated", "==", params.isDeactivated);
  if (params?.endDate !== undefined) collectionRef = collectionRef.where("endDate", ">", params.endDate.toMillis());

  return collectionRef.withConverter<tPromotion>({
    toFirestore: (data) => data,
    fromFirestore: (snapshot) => validate("tPromotion")(snapshot.data()),
  });
};

export const queryBrandAnnouncements = (
  id: string,
  params?: { endDate?: firebase.firestore.Timestamp },
): firebase.firestore.Query<tAnnouncement> => {
  let collectionRef: firebase.firestore.Query = firebase
    .firestore()
    .collection("brands")
    .doc(id)
    .collection("announcements");

  if (params?.endDate !== undefined) collectionRef = collectionRef.where("endDate", ">", params.endDate);

  return collectionRef.withConverter<tAnnouncement>({
    toFirestore: (data) => data,
    fromFirestore: (snapshot) => validate("tAnnouncement")(snapshot.data()),
  });
};
